module.exports = __webpack_public_path__ + "img/Group 6853@2x.f7c6e3f1.png";